var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.717 14.2914C12.921 14.2914 13.901 15.2644 13.901 16.4604V19.5364C13.901 19.7934 14.107 19.9994 14.371 20.0054H16.277C17.779 20.0054 19 18.7994 19 17.3174V8.59337C18.993 8.08337 18.75 7.60337 18.333 7.28437L11.74 2.02637C10.855 1.32537 9.617 1.32537 8.729 2.02837L2.181 7.28237C1.748 7.61137 1.505 8.09137 1.5 8.61037V17.3174C1.5 18.7994 2.721 20.0054 4.223 20.0054H6.147C6.418 20.0054 6.638 19.7904 6.638 19.5264C6.638 19.4684 6.645 19.4104 6.657 19.3554V16.4604C6.657 15.2714 7.631 14.2994 8.826 14.2914H11.717ZM16.277 21.5054H14.353C13.251 21.4794 12.401 20.6144 12.401 19.5364V16.4604C12.401 16.0914 12.094 15.7914 11.717 15.7914H8.831C8.462 15.7934 8.157 16.0944 8.157 16.4604V19.5264C8.157 19.6014 8.147 19.6734 8.126 19.7414C8.018 20.7314 7.172 21.5054 6.147 21.5054H4.223C1.894 21.5054 0 19.6264 0 17.3174V8.60337C0.01 7.60937 0.468 6.69937 1.259 6.10037L7.794 0.855372C9.233 -0.284628 11.238 -0.284628 12.674 0.853372L19.256 6.10337C20.029 6.69237 20.487 7.60037 20.5 8.58237V17.3174C20.5 19.6264 18.606 21.5054 16.277 21.5054Z",
    fill: "#878787"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.299e3e3dc1a97c35d1260c6b3c8ca1b8.svg";
export { ForwardRef as ReactComponent };